module.exports = __webpack_public_path__ + "static/avatar-34f3ca4b7df76414d31dc1ff2ef2e4a9.jpg";